// import Stack from "./stack"
// import StackJudge from "./stackjudge"
import SingQuestion from "./singquestion"
import EliminateQuestion from "./eliminatequestion"
import EliminateCard from "./eliminatecard"
import DragGroupSentenceQuestion from "./draggroupsentencequestion"
import FillInBackQuestion from "./fillinbackquestion"
import InputFillQuestion from "./inputfillquestion"
import ReadingQuestion from "./readingquestion"
import ColorQuestion from "./colorquestion"
import DragDropQuestion from "./dragdropquestion"
import SpeechQuestion from "./speecchquestion"
import SpeechAnswerQuestion from "./speechanswerquestion"
import DragGroupWordQuestion from "./draggroupwordquestion"
import DragSortPicQuestion from "./dragsortpicquestion"
import DragSortSentenceQuestion from "./dragsortsentencequestion"
import CanvasLineQuestion from "./canvaslinequestion"
import CanvasLinePicQuestion from "./canvaslinepicquestion"

export default {
  install: function (Vue) {
    Vue.component('SingQuestion', SingQuestion);
    Vue.component('EliminateQuestion', EliminateQuestion);
    Vue.component('EliminateCard', EliminateCard);
    Vue.component('DragGroupSentenceQuestion', DragGroupSentenceQuestion);
    Vue.component('FillInBackQuestion', FillInBackQuestion);
    Vue.component('InputFillQuestion', InputFillQuestion);
    Vue.component('ReadingQuestion', ReadingQuestion);
    Vue.component('ColorQuestion', ColorQuestion);
    Vue.component('DragDropQuestion', DragDropQuestion);
    Vue.component('SpeechQuestion', SpeechQuestion);
    Vue.component('DragSortPicQuestion', DragSortPicQuestion);
    Vue.component('DragSortSentenceQuestion', DragSortSentenceQuestion);
    Vue.component('DragGroupWordQuestion', DragGroupWordQuestion);
    Vue.component('CanvasLineQuestion', CanvasLineQuestion);
    Vue.component('CanvasLinePicQuestion', CanvasLinePicQuestion);
    Vue.component('SpeechAnswerQuestion', SpeechAnswerQuestion);
  }
}



// WEBPACK FOOTER //
// ./src/components/public/index.js